"use client";
import { NoItems } from "@/app/(components)/Basic/NoItems";
import { Colors } from "@/shared/constants";
import CollectionItem from "../CollectionItem/CollectionItem";
import { useCollections } from "../hooks/useCollections";
import { ShowMoreButton } from "@/app/(components)/Basic/ShowMoreButton";
import { Loading } from "@/app/(components)/Basic/Loading";
// import CollectionSlider from "../CollectionSlider";

export interface Props {
  searchTerm: string;
  marketplaces: string[];
}

export default function CollectionItemsPagination({
  searchTerm,
  marketplaces,
}: Props) {
  const colors = [Colors.Red, Colors.Green, Colors.Yellow];

  const { collections, hasNextPage, fetchNextPage, isLoading } = useCollections(
    marketplaces,
    searchTerm!,
  );

  return (
    <>
      {collections.length ? (
        <>
          {collections.map((collection, index) => {
            // if (index % 4 === 0) {
            //   return (
            //     <CollectionSlider
            //       className="mb-10 px-5 lg:px-0"
            //       collection={collection}
            //       key={index}
            //     />
            //   );
            // } else {
            return (
              <CollectionItem
                className="px-5"
                title={collection.name}
                artist={collection.artist}
                swap={index % 2 === 0}
                description={collection.description}
                href={`/collection/${collection.slug}`}
                imageSrc={collection.imageUrl}
                imagePlaceholder={collection.imagePlaceholder}
                titleColor={colors[(index % 4) - 1]}
                key={index}
              />
            );
            // }
          })}
          {hasNextPage && (
            <ShowMoreButton
              fetchNextPage={fetchNextPage}
              label="Load more collections"
            />
          )}
        </>
      ) : isLoading ? (
        <Loading spinnerClassName="w-16 h-16" />
      ) : (
        <NoItems message="No items to display" />
      )}
    </>
  );
}
